const React = require("react");
const T = require("prop-types");
const RaisedButton = require("material-ui/RaisedButton").default;
const TextField = require("material-ui/TextField").default;
const {
    useStripe,
    useElements,
    PaymentElement
} = require("@stripe/react-stripe-js");
const Classes = require("./styles.scss");

const CheckoutForm = ({ disableSubmit, onSubmit, purchaseOption }) => {
    const stripe = useStripe();
    const elements = useElements();

    const [promo, setPromo] = React.useState("");

    const onSubmitWrapper = e => {
        e.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        onSubmit(stripe, elements, promo);
    };

    return (
        <form onSubmit={onSubmitWrapper}>
            <PaymentElement />

            <div className={Classes.checkoutCard}>
                <div className="form-group">
                    {purchaseOption.id !== 4 && (
                        <TextField
                            floatingLabelText={"Promo Code (Case Sensitive)"}
                            value={promo}
                            onChange={(_, v) => setPromo(v)}
                            type="text"
                        />
                    )}
                </div>
                <RaisedButton
                    primary
                    disabled={disableSubmit}
                    label="Complete Purchase"
                    type="submit"
                    className={`${Classes.modalButton} purchase_btn`}
                />
            </div>
        </form>
    );
};

CheckoutForm.propTypes = {
    disableSubmit: T.bool.isRequired,
    onError: T.func.isRequired,
    onSubmit: T.func.isRequired,
    purchaseOption: T.object.isRequired
};

export default CheckoutForm;



// WEBPACK FOOTER //
// ./src/components/CheckoutForm/index.js